export default __webpack_public_path__ + "static/media/prdct-img.85aeec2f.jpg";